interface OrderGuestsCountSource {
  visitors_count?: number
  children_ages?: number[]
}

export const getOrderGuestsCount = ({
  visitors_count = 0,
  children_ages = [],
}: OrderGuestsCountSource): number => visitors_count + children_ages.length
